import Reflux          from 'reflux';
import StoreState      from 'mixins/store_state';
import ChapterActions  from 'actions/chapter_actions';
import SegmentStore    from 'mixins/segment_store';
import { includes }    from '_';

export default Reflux.createStore({
  listenables: [ ChapterActions ],
  mixins: [ StoreState, SegmentStore ],
  stateNamespace:  'videoLocks',
  segmentProperty: 'locks',
  segmentKey:      'lock',
  onLoadLocks(locks) {//console.log('onLoadLocks: ',locks);
    this.setState({
      lockChildren: locks
    });
  },
  onRemoveLocks(locks) {//console.log('onRemoveLocks: ',locks);
    const remainingLocks = this.state.lockChildren.filter((inLock) => {
      return !includes(locks, inLock);
    });

    let cookieName = 'guidedVideo',
        cookie = 1,
        lastUnlockedVideo = 1,
        i = 1;

    this.setState({
      lockChildren: remainingLocks
    });

    cookie = this.getCookie(cookieName);

    if(cookie >= 1) {//console.log('cookie > 1');
      lastUnlockedVideo = locks;
      this.createCookie(cookieName,lastUnlockedVideo,2);
    } else {//console.log('cookie 1 or lower');
      this.createCookie(cookieName,lastUnlockedVideo,2);
    }

    // Code to unlock the top menu playlist for mobile/tablet
    $(".chapter-link-in-menu").each(function(index) {
      let chapterId = $(this)[0].id;
      //console.log('lastUnlockedVideo', lastUnlockedVideo);
      for(i; i<= lastUnlockedVideo; i++) {
        $('#chapter-'+i).removeClass('gray-out');
        $('#chapter-'+i).removeClass('hide-playlist');
      }
    });
  },
  createCookie(name,value,days) {//console.log('createCookie: '+name+',value: '+value+', days: '+days);
    let expires = "";

    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  },
  getCookie(name) {//console.log('getCookie: ',name);
      let nameEQ = name + "=",
          ca = document.cookie.split(';'),
          i = 0, c = '';
      for(i;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
      }
      return 1;
  }
});



// WEBPACK FOOTER //
// ./modules/stores/chapter_store.js